import {
	AbstractJastVisitor,
	type AstNode,
	isOperandNode,
	type TerminalClause,
} from '@atlaskit/jql-ast';

export type Result = TerminalClause[];

/**
 * Returns all AST terminal clauses that match the provided field's JQL term (case-insensitive)
 */
export class ClauseCollectingVisitor extends AbstractJastVisitor<Result> {
	protected jqlTerm: string;

	constructor(jqlTerm: string) {
		super();
		this.jqlTerm = jqlTerm;
	}

	visitTerminalClause = (terminalClause: TerminalClause): Result => {
		if (terminalClause.field.value.toLowerCase() === this.jqlTerm.toLowerCase()) {
			return [terminalClause];
		}

		return [];
	};

	protected shouldVisitNextChild(node: AstNode): boolean {
		// Skip visiting operand subtrees, which aren't needed for clause collection and can make a big impact on performance
		return !isOperandNode(node);
	}

	protected aggregateResult(aggregate: Result, nextResult: Result): Result {
		return aggregate.concat(nextResult);
	}

	protected defaultResult(): Result {
		return [];
	}
}
